<template>
  <h1 class="text-center" style="width: 100%;">404<br /> Page not found <br /> <router-link to="/"> Home page </router-link></h1>
</template>
<script>
export default {
  name: 'Page404',
  metaInfo: {
    title: '404 - Page Not Found'
  }
}
</script>
